<template>
  
  <div class="vld-parent">
  

    <!-- Subscription overlay -->
    <b-overlay
      :show="show"
      variant="transparent"
      :opacity="1"
      blur="3px"
    >
      <template v-slot:overlay>
        <div class="text-center">
          <p id="cancel-label">
            Please upgrade your subscription to activate this feature
          </p>
          <b-button
            ref="cancel"
            variant="primary"
            aria-describedby="cancel-label"
            @click="upgradeSubscription()"
          >
            Click here to upgrade
          </b-button>
        </div>
      </template>

      <!-- User Interface controls -->

      <b-row>
        <b-col md="8">
          <h4 class="font-weight-bold ml-1">Mannskap</h4>
        </b-col>

        <b-col md="1">
          <div class="float-right">
            <label class="nav-item navbar-text navbar-search-box p-0 active">
              <i class="ion ion-ios-search navbar-icon align-middle"></i>
              <span class="navbar-search-input pl-2">
                <b-form-input
                  class="ml-2"
                  v-model="filter"
                  placeholder="Search"
                ></b-form-input>
              </span>
            </label>
          </div>
        </b-col>

        <b-col md="3">
          <b-button
            class="float-right"
            variant="primary"
            v-b-modal.newCrew
            @click="newCrewModal()"
          >Nytt mannskap</b-button>
        </b-col>

      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="crews"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        empty-text="There are no crew to show"
      >
        <template v-slot:table-caption>Total: {{ crews.length | numeralFormat }} mannskap
        </template>

        <template #cell(actions)="row">

          <b-button
            variant="primary"
            class="mr-1 float-center"
            size="sm"
            @click="editCrew(row.item)"
          >
            Rediger</b-button>
        </template>

      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-overlay>

    <!-- Modal: New crew -->

    <b-modal
      id="newCrew"
      title="Nytt mannskap"
    >
      <b-form-group label="Navn">
        <b-form-input
          id="name-input"
          v-model="crew.name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Rolle">
        <b-form-select
          class="mr-3 mb-3"
          v-model="crew.role"
          :options="roleOptions"
          placeholder="Type"
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Fartøy">
        <b-form-select
          class="mr-3 mb-3"
          v-model="crew.vessel"
          :options="vesselSelect"
        ></b-form-select>
      </b-form-group>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right"
            @click="newCrew()"
          >
            Opprett mannskap
          </b-button>

          <b-button
            variant="default"
            class="float-right mr-2"
            @click="closeModal()"
          >
            Avbryt
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- Modal: Edit crew -->

    <b-modal
      id="editCrew"
      title="Rediger mannskap"
    >
      <b-form-group label="Navn">
        <b-form-input
          id="name-input"
          v-model="crew.name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Rolle">
        <b-form-select
          class="mr-3 mb-3"
          v-model="crew.role"
          :options="roleOptions"
          placeholder="Type"
        ></b-form-select>
      </b-form-group>

      <b-form-group label="Fartøy">
        <b-form-select
          class="mr-3 mb-3"
          v-model="crew.vessel"
          :options="vesselSelect"
        ></b-form-select>
      </b-form-group>

      <template #modal-footer>
        <div class="w-100">

          <b-button
            variant="outline-danger"
            class="float-left"
            @click="deleteCrew()"
          >
            Slett
          </b-button>

          <b-button
            variant="primary"
            class="float-right"
            @click="saveCrew()"
          >
            Lagre
          </b-button>

          <b-button
            variant="default"
            class="float-right mr-2"
            @click="closeEditModal()"
          >
            Avbryt
          </b-button>
        </div>
      </template>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";

import Vue2Filters from "vue2-filters";
import Datepicker from "vuejs-datepicker";
import VueMoment from "vue-moment";
import moment from "moment";




export default {
  components: {
    Datepicker,
    VueMoment,
    moment,

  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      crew: {},
      crews: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        {
          key: "name",
          label: "Navn",
          sortable: true,
          class: "text-left",
        },
        {
          key: "role",
          label: "Rolle",
          sortable: true,
          class: "text-left",
        },
        {
          key: "vessel.name",
          label: "Fartøy",
          sortable: true,
          class: "text-left",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-left",
        },
        {
          key: "active",
          label: "Aktiv",
          sortable: true,
          class: "text-left",
        },
        {
          key: "actions",
          label: "Handlinger",
          class: "text-left",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "created",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      limit: 1000,
      stages: ["on-hold", "in-progress", "needs-review", "approved"],
      roleOptions: [
        { value: "Skipper", text: "Skipper" },
        { value: "Styrmann", text: "Styrmann" },
        { value: "Matros", text: "Matros" },
        { value: "Motormann", text: "Motormann" },
        { value: "Kokk", text: "Kokk" },
        { value: "Dekksmann", text: "Dekksmann" },
        { value: "Maskinist", text: "Maskinist" },
        { value: "Kadett", text: "Kadett" },
        { value: "Båtfører", text: "Båtfører" },
        { value: "Operatør", text: "Operatør" },
        { value: "Lærling", text: "Lærling" },
        { value: "Maskinpasser", text: "Maskinpasser" },
        { value: "Matros/Kokk", text: "Matros/Kokk" },
        { value: "Flåteansvarlig", text: "Flåteansvarlig" },
      ],
      vesselSelect: [],
      show: false,
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumShipsTotal() {
      return this.ships.length;
    },
  },
  methods: {
    getCrew() {
      this.isLoading = true;
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/crews?_where[company]=" + company)
        .then((res) => {
          this.crews = res.data;
          this.isLoading = false;
        });
    },
    getVessels() {
      var company = localStorage.getItem("company");

      axios
        .get("https://api.eines-as.no/vessels?_where[company]=" + company)
        .then((response) => {
          var vesselSelect = [];
          var vesselDataArray = response.data;

          vesselDataArray.forEach((data) => {
            var vesselObject = {
              value: data,
              text: data.name,
            };
            vesselSelect.push(vesselObject);
          });

          this.vesselSelect = vesselSelect;
        });
    },
    newCrew() {
      this.crew.company = localStorage.getItem("company");
      axios
        .post("https://api.eines-as.no/crews/", this.crew)
        .then((response) => {
          this.crew = {};
          this.$bvModal.hide("newCrew");
          this.crews.push(response.data);
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    saveCrew() {
      axios
        .put("https://api.eines-as.no/crews/" + this.crew.id, this.crew)
        .then(() => {
          this.$bvModal.hide("editCrew");
          this.getCrew();
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    deleteCrew() {
      axios
        .delete("https://api.eines-as.no/crews/" + this.crew.id)
        .then(() => {
          this.getCrew();
          this.$bvModal.hide("editCrew");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    editCrew(crew) {
      this.crew = crew;
      this.$bvModal.show("editCrew");
    },
    newCrewModal() {
      this.crew = {};
    },
    closeNewModal() {
      this.$bvModal.hide("newCrew");
    },
    closeEditModal() {
      this.$bvModal.hide("editCrew");
    },
    closeModal() {
      this.$bvModal.hide("newCrew");
    },
    add: function () {
      this.crews.push({ name: "Juan" });
    },
    replace: function () {
      this.crews = [{ name: "Edgard" }];
    },
    clone: function (el) {
      return {
        name: el.name + " cloned",
      };
    },
    log: function (evt) {
      window.console.log(evt);
    },
  },
  created: function () {
    this.getCrew();
    this.getVessels();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>